import React from 'react';
import AuthModal from './AuthModal';
import { useAuth } from '../context/AuthContext';

/**
 * Mounts the sign-in dialog once, for the whole app.
 *
 * Any page can open it with useAuth().requireAuth(reason, after) without
 * importing or rendering a modal itself — which is what keeps the gate on a
 * locked listing down to a single line.
 */
export default function AuthGate() {
  const { authPrompt, closeAuthPrompt } = useAuth();
  return (
    <AuthModal
      open={Boolean(authPrompt)}
      reason={authPrompt?.reason}
      onClose={closeAuthPrompt}
    />
  );
}
